// extracted by mini-css-extract-plugin
module.exports = {"block":"_9293"};